// @ts-nocheck
import { CartActions } from "@theme/cart-actions";
import { ThemeEvents } from "@theme/events";
import { PULeatherSheathsPDP } from "@theme/utilities";

(function () {
  "use strict";

  const cartActions = new CartActions();

  function parseGiftVariants(raw) {
    if (!raw) return [];
    return raw
      .split(",")
      .map((id) => parseInt(id.trim(), 10))
      .filter((id) => Number.isFinite(id) && id > 0)
      .map((id) => ({
        id,
        quantity: 1,
        properties: { _source: "premade-gift" },
      }));
  }

  function getSectionConfig(sectionEl) {
    const sectionId = sectionEl.dataset.sectionId || "";
    const configEl = document.getElementById(
      `premade-combo-config-${sectionId}`
    );

    if (configEl?.textContent) {
      try {
        const parsed = JSON.parse(configEl.textContent);
        const giftIds = Array.isArray(parsed.giftVariantIds)
          ? parsed.giftVariantIds
          : [];
        return {
          giftVariants: giftIds
            .map((id) => parseInt(String(id).trim(), 10))
            .filter((id) => Number.isFinite(id) && id > 0)
            .map((id) => ({
              id,
              quantity: 1,
              properties: { _source: "premade-gift" },
            })),
        };
      } catch (_) {
        /* fall through to data attributes */
      }
    }

    return {
      giftVariants: parseGiftVariants(
        sectionEl.dataset.giftVariantIds || ""
      ),
    };
  }

  function getOrderedCards(grid) {
    const blocks = [...grid.querySelectorAll(":scope > .shopify-block")];
    return blocks
      .sort((a, b) => {
        const orderA = parseInt(getComputedStyle(a).order, 10) || 0;
        const orderB = parseInt(getComputedStyle(b).order, 10) || 0;
        return orderA - orderB;
      })
      .map((block) => block.querySelector(".premade__card"))
      .filter(Boolean);
  }

  function initCarousel(sectionEl) {
    const sectionId = sectionEl.dataset.sectionId || "";
    const gridEl = document.getElementById(`premadeGrid-${sectionId}`);
    const dots = sectionEl.querySelectorAll(".premade__dot");

    if (!gridEl || !dots.length) return;
    const grid = gridEl;

    function updateDots() {
      const cards = getOrderedCards(grid);
      const first = cards[0];
      if (!first) return;
      const block = first.closest(".shopify-block");
      const cardWidth = (block || first).offsetWidth + 10;
      let idx = Math.round(grid.scrollLeft / cardWidth);
      idx = Math.max(0, Math.min(idx, dots.length - 1));
      dots.forEach((d, i) => {
        d.classList.toggle("premade__dot--active", i === idx);
      });
    }

    grid.addEventListener("scroll", updateDots, { passive: true });

    dots.forEach((dot) => {
      dot.addEventListener("click", function () {
        const idx = parseInt(this.dataset.index || "0", 10);
        const cards = getOrderedCards(grid);
        const target = cards[idx];
        if (target) {
          const scrollTarget = target.closest(".shopify-block") || target;
          scrollTarget.scrollIntoView({
            behavior: "smooth",
            inline: "start",
            block: "nearest",
          });
        }
      });
    });
  }

  function initATC(sectionEl) {
    const { giftVariants } = getSectionConfig(sectionEl);

    sectionEl.querySelectorAll(".premade__atc").forEach((node) => {
      const btn = node;
      btn.addEventListener("click", (event) => {
        event.preventDefault();

        if (btn.disabled) return;

        const card = btn.closest(".premade__card");
        if (!card) return;

        const variantsAttr = card.dataset.variants || "";
        const bundle = card.dataset.bundle || "";

        let items = variantsAttr
          .split(",")
          .map((id) => parseInt(id.trim(), 10))
          .filter((id) => Number.isFinite(id) && id > 0)
          .map((id) => ({
            id,
            quantity: 1,
            properties: { _source: "premade", _bundle: bundle },
          }));

        items = items.flatMap((item) => [item, ...PULeatherSheathsPDP(item)]);

        if (items.length === 0) return;

        const allItems = items.concat(giftVariants);

        const originalHTML = btn.innerHTML;
        btn.disabled = true;
        btn.textContent = "Adding...";

        try {
          window.igEvents = window.igEvents || [];
          window.igEvents.push({ event: "premade-combo-atc" });
        } catch (_) {
          /* analytics is optional */
        }

        const restoreButton = () => {
          btn.disabled = false;
          btn.innerHTML = originalHTML;
        };

        const onError = () => {
          document.removeEventListener(ThemeEvents.cartError, onError);
          restoreButton();
        };
        document.addEventListener(ThemeEvents.cartError, onError, {
          once: true,
        });

        window.CartAllItemsCount = allItems.length;

        cartActions.addItems(allItems, () => {
          document.removeEventListener(ThemeEvents.cartError, onError);
          btn.textContent = "Added \u2713";

          const cartDrawerDialog = document.querySelector(
            ".cart-drawer__dialog"
          );
          const cartDrawer = document.querySelector("cart-drawer-component");

          if (cartDrawer && cartDrawerDialog) {
            cartDrawer.open();
            cartDrawerDialog.classList.remove("cart-drawer--empty");
          }

          setTimeout(restoreButton, 1800);
        });
      });
    });
  }

  function initSection(sectionEl) {
    if (sectionEl.dataset.premadeInitialized === "true") return;
    sectionEl.dataset.premadeInitialized = "true";
    initCarousel(sectionEl);
    initATC(sectionEl);
  }

  function bootstrap() {
    document
      .querySelectorAll(".premade-combo-offer-section")
      .forEach((el) => initSection(el));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    const section = target.querySelector(".premade-combo-offer-section");
    if (section instanceof HTMLElement) initSection(section);
  });
})();
